import React from 'react';
import styled from '@emotion/styled';

import { CardStyled } from './Card';

const StyledCard = styled(CardStyled)`
  min-height: 230px;
  overflow: hidden;
  position: relative;
  transition: all .3s ease-in-out;
  cursor: pointer;
 
  background-image: linear-gradient(225deg, ${props => props.colourOne} 0%, ${props => props.colourTwo} 100%);
  
  :hover {
    transform: scale(1.01);
  }
  
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
`;

const StyledBigCard = styled(StyledCard)`
  height: 600px;
  grid-row-end: span 2;
  
  @media (max-width: 840px) {
    height: 230px;
  }
`;


const BigProjectCard = ({ children, ...props }) => (
  <StyledBigCard {...props}>
    {children}
  </StyledBigCard>
);

const DefaultProjectCard = ({ children, ...props }) => (
  <StyledCard {...props}>
    {children}
  </StyledCard>
);

export default ({ big, children, ...props }) => (
  big ? (
    <BigProjectCard {...props}>
      {children}
    </BigProjectCard>
    ) :
    (
      <DefaultProjectCard {...props}>
        {children}
      </DefaultProjectCard>
    )
);
